<div fxLayoutAlign="center center"><h2>Error</h2></div>
<div fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="40" fxFlex.md="50" fxFlex.sm="80" fxFlex.xs="95">
        <div fxLayoutAlign="center center">
            <button mat-button [routerLink]="['/default']" class="navigation-button navigation-button-back">Main Page</button>
        </div>
    </div>
</div>
